import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";
import { ContestService } from "../../../services/contest.service";
import { LoaderService } from "../../../loader/LoaderService";
import { Broadcaster } from "../../../app.broadcaster";
import { EventPrefixValue, MatchType } from "../../../app.config";
import { AppConfig } from "../../../app.config";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

declare var $: any;

@Component({
  selector: "app-team-preview",
  templateUrl: "./team-preview.component.html",
  styleUrls: ["./team-preview.component.css"],
})
export class TeamPreviewComponent implements OnInit, OnChanges {
  @Input() teamid: string;
  @Input() seriesid: string;
  @Input() matchid: string;
  @Input() teamName: string;
  @Input() status: string;
  @Input() testOrOdi: string;
  @Input() userSportType: number;
  @Input() leagueId: number;
  @Input() isPreview: boolean;
  message: string;
  prviewData: any;
  savedMatchType: string;
  matchType: any;
  showPopUp: boolean;
  @Input() previewList;
  @Input() previewList2;
  isFirst: boolean;
  condition: any;
  sortType: string;
  eventPrefixValue = EventPrefixValue;
  finalList = [];
  sortReverse: boolean;
  urlDataTemp: SafeResourceUrl;
  format: any;
  matchValData: any;
  sportTypeData: any;

  constructor(
    public commonService: CommonService,
    private contestService: ContestService,
    private loaderService: LoaderService,
    private broadcaster: Broadcaster,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.matchType = MatchType;
    this.broadcaster.broadcast("showPreview", false);
  }

  ngOnInit() {
    this.commonService.hideModel();
    if (localStorage.getItem("formatPointData")) {
      this.format = localStorage.getItem("formatPointData");
    }
    if (localStorage.getItem("match_info")) {
      this.sportTypeData = JSON.parse(localStorage.getItem("match_info"));
    }
    this.savedMatchType = this.contestService.getSportType();
    this.isFirst = true;
    this.sortType = "sortKey";
    this.sortReverse = true;
    if (this.matchid) {
      const userInfo1 = this.commonService.getTokenInfo(true);
      userInfo1.push({ name: "SportsID", value: this.savedMatchType });
      let lanCode = "en";
      if (localStorage.getItem("saveLanguage")) {
        lanCode = JSON.parse(localStorage.getItem("saveLanguage")).language;
      }
      userInfo1.push({ name: "LanguageCode", value: lanCode });
      userInfo1.push({ name: "matchID", value: this.matchid });
      this.commonService
        .apiRequest4("team/v1/logic/" + this.matchid, "get", userInfo1)
        .then((response2: any) => {
          for (const item of response2.data.categories) {
            this.finalList.push({ key: item.name, role: item.role, value: [] });
          }
        });
    }
  }

  bindClassBehalfSportType() {
    if (this.userSportType) {
      this.userSportType = +this.userSportType;
      return {
        show: this.showPopUp === true,
        rugby_preview: this.commonService.getSportTypeInfo() === 10,
      };
    } else {
      return {
        show: this.showPopUp === true,
        rugby_preview: this.commonService.getSportTypeInfo() === 10,
      };
    }
  }

  edit() {
    this.router.navigate(
      ["/sports/create-team/" + this.matchid + "/" + this.teamid],
      { queryParams: { returnUrl: this.router.url } }
    );
  }
  redirectOpenModal() {
    this.commonService.winningBreakupModelOpen("pointsystems");
    const languageInfo = this.commonService.getSavedLanguageInfo();
    if (this.format) {
      //  this.title = this.commonService.label.more.legalities;
      setTimeout(() => {
        const urlTemp =
          AppConfig.webUrl +
          languageInfo.language +
          "/web-fantasy-points-system.html?sport=" +
          this.sportTypeData.matchType +
          "&type=" +
          this.format;
        this.urlDataTemp =
          this.sanitizer.bypassSecurityTrustResourceUrl(urlTemp);
      });
    } else {
      setTimeout(() => {
        const urlTemp =
          AppConfig.webUrl +
          languageInfo.language +
          "/web-fantasy-points-system.html?sport=" +
          this.sportTypeData.matchType;
        this.urlDataTemp =
          this.sanitizer.bypassSecurityTrustResourceUrl(urlTemp);
      }, 0);
    }
  }

  ngOnChanges() {
    if (this.teamid) {
      this.showPopUp = true;
      this.isFirst = true;
      this.getTeamPreview();
    } else {
      this.showPopUp = false;
      this.isFirst = false;
    }

    const owl = $(".team_preview_slider");
    owl.on("changed.owl.carousel", (event) => {
      if (event && event.item.index !== null && !this.isFirst) {
        if (!this.previewList[event.item.index].isDataGet) {
          this.teamid = this.previewList[event.item.index].teamid;
          this.getTeamPreview();
        }
      }
    });
  }

  getTeamPreview() {
    const userInfo = this.commonService.getTokenInfo(true);
    if (this.matchid) {
      userInfo.push({ name: "matchID", value: this.matchid });
      userInfo.push({ name: "teamId", value: this.teamid });
    } else {
      let lanCode = "en";
      const userInfo1 = this.commonService.getTokenInfo(true);
      userInfo1.push({ name: "SportsID", value: this.savedMatchType });
      if (localStorage.getItem("saveLanguage")) {
        lanCode = JSON.parse(localStorage.getItem("saveLanguage")).language;
      }
      userInfo1.push({ name: "LanguageCode", value: lanCode });
      //userInfo1.push({ name: "matchID", value: this.seriesid });
      this.commonService
        .apiRequest4("team/v1/logic/" + this.seriesid, "get", userInfo1)
        .then((response2: any) => {
          this.finalList = [];
          for (const item of response2.data.categories) {
            this.finalList.push({
              key: item.name,
              role: item.role,
              isActive: true,
              value: [],
            });
          }
        });
      //  userInfo.push({ name: 'matchID', value: this.seriesid });
      //  userInfo.push({ name: 'teamId', value: this.teamid });
    }
    if (localStorage.getItem("matchValData")) {
      this.matchValData = localStorage.getItem("matchValData");
    } else {
      this.matchValData = this.matchid;
    }
    this.commonService
      .apiRequest4(
        this.matchid
          ? "team/v1/preview/" + this.matchValData + "/" + this.teamid
          : "team/v1/preview/" + this.matchValData + "/" + this.teamid,
        "get",
        userInfo
      )
      .then(
        (response: any) => {
          let index = 0;
          this.commonService.playerListData = [];

          // Helper function to extract IDs from an array and push them to playerListData
          const extractAndPushIds = (dataArray) => {
            dataArray.forEach((item) => {
              this.commonService.playerListData.push(item.id);
            });
          };

          // Extract IDs from each relevant array in response.data
          extractAndPushIds(response.data.all);
          extractAndPushIds(response.data.bat);
          extractAndPushIds(response.data.bowl);
          extractAndPushIds(response.data.ext);
          extractAndPushIds(response.data.extNew);
          extractAndPushIds(response.data.extOne);
          extractAndPushIds(response.data.wk);
          if (this.previewList) {
            index = this.previewList.findIndex((o) => {
              return o.teamid === this.teamid;
            });
          }
          this.condition = response;
          setTimeout(() => {
            for (const item of this.finalList) {
              const index = this.finalList.indexOf(item);
              if (this.finalList[index].role === "WK") {
                if (response.data.wk.length > 0) {
                  this.finalList[index].value = response.data.wk;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "Batsmen") {
                if (response.data.bat.length > 0) {
                  this.finalList[index].value = response.data.bat;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "All-Rounders") {
                if (response.data.all.length > 0) {
                  this.finalList[index].value = response.data.all;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "Bowlers") {
                if (response.data.bowl.length > 0) {
                  this.finalList[index].value = response.data.bowl;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "Extra") {
                if (response.data.ext.length > 0) {
                  this.finalList[index].value = response.data.ext;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "ExtraNew") {
                if (response.data.extNew.length > 0) {
                  this.finalList[index].value = response.data.extNew;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "ExtraOne") {
                if (response.data.ExtOne.length > 0) {
                  this.finalList[index].value = response.data.extOne;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              } else if (this.finalList[index].role === "ExtraTwo") {
                if (response.data.extTwo.length > 0) {
                  this.finalList[index].value = response.data.extTwo;
                  this.finalList[index].isActive = true;
                } else {
                  this.finalList[index].isActive = false;
                }
              }
            }
            if (this.previewList && index >= 0) {
              this.prviewData = null;
              this.previewList[index].isDataGet = true;
              this.previewList[index].previewList = this.finalList.map((x) =>
                Object.assign({}, x)
              );
              this.previewList[index].previewList["t1Id"] = response.data.t1Id;
              this.previewList[index].previewList["groundImg"] =
                response.data.groundImg;
              this.previewList[index].previewList["previewRows"] =
                response.data.previewRows;
              this.previewList[index].previewList["imgShow"] =
                response.data.imgShow;
              this.previewList[index].previewList["t2Id"] = response.data.t2Id;
              this.previewList[index].previewList["t3Id"] = response.data.t3Id;
              setTimeout(() => {
                const carousel = $(".team_preview_slider");
                $(".team_preview_slider").owlCarousel({
                  loop: false,
                  nav: true,
                  items: 1,
                });
                setTimeout(() => {
                  carousel.trigger("to.owl.carousel", index);
                  this.isFirst = false;
                }, 250);
              });
            } else {
              this.prviewData = this.finalList;
              this.prviewData["Team1Id"] = response.data.t1Id;
              this.prviewData["GroundImage"] = response.data.groundImg;
              this.prviewData["PreviewRowCount"] = response.data.previewRows;
              this.prviewData["ImageShow"] = response.data.imgShow;
              this.prviewData["Team2Id"] = response.data.t2Id;
            }
          }, 500);
        },
        (error) => {
          this.broadcaster.broadcast("message", {
            type: "error",
            message: error,
          });
        }
      );
  }

  redirect(item) {
    if (
      (this.savedMatchType.toString() === "1" ||
        this.savedMatchType.toString() === "5" ||
        this.savedMatchType.toString() === "2" ||
        this.savedMatchType.toString() === "3") &&
      (this.commonService.matchStatus === "started" ||
        this.commonService.matchStatus === "completed" ||
        this.commonService.leaderBoardCall == true)
    ) {
      const leagueid = this.leagueId ? this.leagueId : 0;
      this.router.navigate([
        "/player-info/" +
          item.id +
          "/" +
          this.testOrOdi +
          "/" +
          this.teamid +
          "/" +
          item.name +
          "/" +
          this.matchid +
          "/" +
          leagueid,
      ]);
    } else if (
      this.commonService.matchStatus === "notstarted" &&
      (this.savedMatchType.toString() === "1" ||
        this.savedMatchType.toString() === "5")
    ) {
      this.broadcaster.broadcast("message", {
        type: "error",
        message: this.commonService.label.message.validationOnPreview,
      });
    }
  }

  close() {
    this.broadcaster.broadcast("showPreview", false);
    this.showPopUp = false;
    this.teamid = "";
  }
}
